<template>
  <b-container>
    <b-row align-h="center" v-if="profileUser._id">
      <b-col cols="12" md="8" lg="6" class="py-3">
        <b-form @submit.prevent="updateProfile">
          <b-form-group :label="$t('profile:user-name-label')+ ' (' + $t('common:optional') + ')'"
                        label-for="user-name">
            <b-form-input id="user-name"
                          name="user-name"
                          type="text"
                          v-model="profileUser.name"
                          :placeholder="$t('profile:user-name-placeholder')">
            </b-form-input>
          </b-form-group>
          <inline-language-changer />
          <!-- <b-form-group :label="$t('profile:birthday')+ ' (' + $t('common:optional') + ')'"
                        label-for="birthday">
            <b-form-datepicker
              id="birthday"
              v-model="value"
              :min="birthdayMin"
              :max="birthdayMax"
              :locale="$i18n.i18next.language"
              show-decade-nav="true"
              initial-date="1985-06-06"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
          </b-form-group> -->
          <!-- <b-form-group :label="$t('profile:gender')+ ' (' + $t('common:optional') + ')'"
                        label-for="gender">
            <b-form-select id="gender" v-model="gender" :options="genderOptions"></b-form-select>
          </b-form-group>
          <b-form-group v-if="gender == 'other'">
            <b-form-input id="gender-other"
                          name="gender-other"
                          type="text"
                          v-model="genderOther"
                          :placeholder="$t('profile:gender-other-placeholder')">
            </b-form-input>
          </b-form-group> -->
          <!-- <b-form-group :label="$t('profile:occupation')+ ' (' + $t('common:optional') + ')'"
                        label-for="occupation">
            <b-form-select id="occupation" v-model="occupation" :options="occupationOptions"></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('profile:education')+ ' (' + $t('common:optional') + ')'"
                        label-for="education">
            <b-form-select id="education" v-model="education" :options="educationOptions"></b-form-select>
          </b-form-group> -->
          <b-form-group class="text-right">
            <b-button id="submit-button_save-profile-details" type="submit" variant="success" :disabled="updateProfileState.loading" :class="{ loading: updateProfileState.loading }">{{$t('common:save')}}</b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import InlineLanguageChanger from './components/InlineLanguageChanger'

export default {
  components: {
    InlineLanguageChanger
  },
  data () {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setYear(minDate.getFullYear() - 100)
    const maxDate = new Date(today)
    maxDate.setYear(maxDate.getFullYear() - 15)
    return {
      profileUser: {},
      updateProfileState: {
        loading: false,
        success: false,
        failure: false
      },
      birthdayMin: minDate,
      birthdayMax: maxDate,
      gender: null,
      genderOptions: [
        { value: 'male', text: this.$t('common:gender-male') },
        { value: 'female', text: this.$t('common:gender-female') },
        { value: 'other', text: this.$t('common:gender-other') },
        { value: 'rather not say', text: this.$t('common:gender-rather-not-say') }
      ],
      occupation: null,
      occupationOptions: [
        { value: 'student', text: 'A student' },
        { value: 'self-employed', text: 'Self-employed' },
        { value: 'employed', text: 'Employed for wages' },
        { value: 'military-government', text: 'Military/Government' },
        { value: '', text: 'Professional/technical（teachers, doctors, lawyer and so on)' },
        { value: '', text: 'Unemployed' },
        { value: '', text: 'Retired' },
        { value: '', text: 'Others' }
      ],
      education: null,
      educationOptions: [
        { value: 'primary-school-or-below', text: 'Primary school or below' },
        { value: 'middle-school', text: 'Middle school' },
        { value: 'high-scool', text: 'High school / Vocational education / technical school' },
        { value: 'associates-degree', text: 'Associate’s degree' },
        { value: 'bachelors-degree', text: 'Bachelor’s degree' },
        { value: 'masters-degree-above', text: 'Master’s degree and above' }
      ]
    }
  },
  mounted: function () {
    this.profileUser = this.$store.state.user
  },
  methods: {
    updateProfile () {
      this.updateProfileState.loading = true
      this.updateProfileState.failure = false
      this.updateProfileState.success = false
      this.axios.post('/users/' + this.$store.state.user._id, { user: this.profileUser }).then((response) => {
        this.$store.dispatch('updateUser', response.data.user)
        this.updateProfileState.success = true
        this.updateProfileState.loading = false
        this.$bvToast.toast(this.$t('common:changes-saved'), {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          noCloseButton: true,
          autoHideDelay: 1000
        })
      }).catch(() => {
        this.updateProfileState.failure = true
        this.updateProfileState.loading = false
      })
    }
  },
  computed: {
    ...mapGetters(['user', 'numberOfPendingQuestions'])
  },
  watch: {
    user (value) {
      this.profileUser = value
    },
    messagingOptions: {
      deep: true,
      handler () {
        this.makeToast()
      }
    }
  }
}
</script>
